export const gobalSectionDelay = 250
export const gobalSectionDuration = 250
export const GobalSectionRootMargin = '-40% 0%'
export const gobalFromSectionTranslateY = 'translateY(-10px)'
export const gobalToSectionTranslateY = 'translateY(0px)'
export const globalToSectionTranslateX1 = 'translateX(-10px)'
export const globalToSectionTranslateX2 = 'translateX(0px)'
export const globalToSectionTranslateX3 = 'translateX(10px)'
export const globalToSectionTranslateX4 = 'translateX(0px)'